import React, { useState, useEffect } from 'react';
import { useLanguage } from './contexts/LanguageContext';
import ChatInterface from './components/ChatInterface';
import './SimulationTrainingPage.css';

// 生成随机会话ID
const generateSessionId = () => {
  return 'guest_' + Math.random().toString(36).substring(2, 15);
};

const SimulationTrainingPage = ({ deadline, username, purpose, onBack }) => {
  const { language } = useLanguage();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userData, setUserData] = useState(null);
  const [sessionId, setSessionId] = useState('');

  // 检查用户登录状态
  useEffect(() => {
    const storedUser = localStorage.getItem('talktastic_user');
    if (storedUser) {
      try {
        const user = JSON.parse(storedUser);
        if (user && user.isRegistered) {
          setIsLoggedIn(true);
          setUserData(user);
          setSessionId(user.email);
        } else {
          initGuestSession();
        }
      } catch (error) {
        console.error('读取用户信息失败:', error);
        initGuestSession();
      }
    } else {
      initGuestSession();
    }
  }, []);

  // 初始化游客会话
  const initGuestSession = () => {
    let guestId = localStorage.getItem('talktastic_guest_id');
    if (!guestId) {
      guestId = generateSessionId();
      localStorage.setItem('talktastic_guest_id', guestId);
    }
    setSessionId(guestId);
    
    const now = new Date().toISOString();
    localStorage.setItem('talktastic_guest_created', now);
  };

  // 根据登录状态决定用户名
  const displayUsername = isLoggedIn && userData?.username ? userData.username : "You";

  return (
    <ChatInterface 
      username={displayUsername}
      sessionId={sessionId}
      language={language}
      onBack={onBack}
    />
  );
};

export default SimulationTrainingPage;
